import type { StandardServicePageContent } from "~/content/servicePage";

export const AirConditioningInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd klimatyzacji",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Minimum raz w roku",
      description:
        "Najlepszy moment to okres przed sezonem letnim. W biurach, lokalach usługowych i przy intensywnym użytkowaniu klimatyzacji rozsądny bywa serwis dwa razy w roku.",
    },
    {
      label: "Ile kosztuje",
      value: "Najczęściej 200-450 zł za jeden split",
      description:
        "Cena zależy od liczby jednostek, zakresu czyszczenia, dezynfekcji i miasta. Kilka urządzeń w domu albo lokalu jest zwykle wycenianych pakietowo.",
    },
    {
      label: "Co obejmuje",
      value: "Czyszczenie, dezynfekcję i ocenę pracy urządzenia",
      description:
        "Typowy serwis obejmuje filtry, parownik, odpływ skroplin, elementy obudowy, podstawowe parametry pracy i kontrolę jednostki zewnętrznej. Po wizycie łatwiej ocenić, czy potrzebna jest naprawa.",
    },
    {
      label: "Kiedy działać wcześniej",
      value: "Przy słabym chłodzeniu, zapachu lub wycieku",
      description:
        "Nieprzyjemny zapach, kapanie wody, głośniejsza praca i wolniejsze schładzanie pomieszczenia zwykle oznaczają zabrudzenie, problem ze skroplinami albo potrzebę dalszej diagnostyki.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd klimatyzacji",
  sections: [
    {
      title: "Na czym polega przegląd klimatyzacji i co obejmuje",
      paragraphs: [
        `Przegląd klimatyzacji to kontrola urządzenia pod kątem wydajności chłodzenia, higieny pracy oraz bezpieczeństwa eksploatacji. Celem nie jest wyłącznie szybkie odkurzenie filtra, ale sprawdzenie, czy cały układ działa stabilnie i nie wykazuje oznak zużycia.`,
        `W praktyce ocenia się jednostkę wewnętrzną i zewnętrzną, filtry, wymienniki, wentylatory, odpływ skroplin, połączenia elektryczne i podstawowe parametry pracy. To właśnie te elementy najczęściej wpływają na spadek wydajności, hałas albo nieprzyjemny zapach po uruchomieniu urządzenia.`,
        `Po dobrze wykonanym serwisie właściciel powinien wiedzieć, czy klimatyzacja chłodzi prawidłowo, czy wymaga tylko standardowej obsługi, czy też pojawiają się sygnały wskazujące na nieszczelność, zabrudzenie albo konieczność naprawy.`,
      ],
    },
    {
      title: "Kiedy wykonywać serwis klimatyzacji i dlaczego nie warto zwlekać",
      paragraphs: [
        `Klimatyzację najlepiej serwisować minimum raz w roku, najlepiej przed sezonem letnim. W pomieszczeniach używanych codziennie, takich jak biura, gabinety czy lokale handlowe, bardziej praktyczny bywa serwis co pół roku.`,
        `Warto działać wcześniej, jeśli urządzenie słabiej chłodzi, pracuje głośniej, ma nieprzyjemny zapach albo pojawia się wyciek skroplin. Zwlekanie zwykle kończy się pogorszeniem komfortu właśnie wtedy, gdy klimatyzacja jest najbardziej potrzebna.`,
        `Regularny przegląd pomaga też utrzymać urządzenie w stanie zgodnym z zaleceniami producenta. Przy części instalacji ma to znaczenie dla gwarancji, a w większych układach również dla obowiązków eksploatacyjnych związanych z urządzeniami chłodniczymi.`,
      ],
    },
    {
      title: "Czyszczenie i dezynfekcja klimatyzacji",
      paragraphs: [
        `Czyszczenie i dezynfekcja to jeden z najważniejszych elementów całego serwisu. W jednostce wewnętrznej gromadzą się kurz, wilgoć i osady organiczne, które pogarszają jakość nawiewanego powietrza i sprzyjają powstawaniu przykrego zapachu.`,
        `Typowy serwis obejmuje czyszczenie filtrów, parownika, obudowy oraz odpływu skroplin, a w razie potrzeby także odgrzybianie i dezynfekcję. W bardziej zaniedbanych urządzeniach zakres prac może być szerszy, bo sama podstawowa obsługa nie przywróci pełnej higieny i wydajności.`,
        `To właśnie po tej części wizyty użytkownik najczęściej widzi najszybszy efekt: lepszy nawiew, mniej zapachu po uruchomieniu i sprawniejsze odprowadzanie skroplin. Dlatego warto pytać nie tylko o przegląd, ale o dokładny zakres czyszczenia.`,
      ],
    },
    {
      title: "Cena przeglądu klimatyzacji",
      paragraphs: [
        `Cena przeglądu klimatyzacji typu split wynosi najczęściej około 200-450 zł za jedną jednostkę. Przy kilku urządzeniach w domu, biurze lub lokalu usługa jest zwykle wyceniana pakietowo i zależy od zakresu czyszczenia oraz dezynfekcji.`,
        `Na koszt wpływa stan urządzenia, liczba jednostek, rodzaj instalacji i lokalny rynek. W większych miastach ceny bywają wyższe w sezonie, szczególnie gdy potrzebny jest szybki termin przed falą upałów.`,
        `Porównując oferty, warto sprawdzić, czy cena obejmuje tylko podstawową kontrolę, czy również czyszczenie, dezynfekcję, ocenę parametrów pracy i zalecenia po serwisie. To zakres usługi zwykle wyjaśnia największe różnice między wykonawcami.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu klimatyzacji",
  scopeItems: [
    "Kontrola jednostki wewnętrznej",
    "Ocena jednostki zewnętrznej",
    "Czyszczenie filtrów",
    "Czyszczenie parownika",
    "Kontrola odpływu skroplin",
    "Dezynfekcja i odgrzybianie",
    "Sprawdzenie połączeń elektrycznych",
    "Ocena parametrów pracy",
  ],
  seo: {
    title: "Przegląd klimatyzacji: cena, czyszczenie, dezynfekcja, serwis",
    description:
      "Przegląd klimatyzacji dla mieszkania, domu i biura. Sprawdź cenę serwisu, zakres czyszczenia i dezynfekcji oraz kiedy wykonać przegląd urządzenia.",
  },
};
